import { IMPLICIT_DATASET_PLACEHOLDER } from "../buildRequestTemplate";

import styles from "./ImplicitDatasetChip.module.css";

/**
 * Read-only display of the ``{{dataset.id}}`` placeholder used by every
 * dataset-typed goal. Not editable: a templated agent always runs against
 * the dataset chosen at launch time, so hardcoding a dataset_id in the
 * agent would be a trap.
 */
export function ImplicitDatasetChip() {
  return (
    <div className={styles.row}>
      <span className={styles.label}>Dataset</span>
      <span className={styles.chip}>{IMPLICIT_DATASET_PLACEHOLDER}</span>
      <span className={styles.help}>
        Bound to the dataset chosen at launch time.
      </span>
    </div>
  );
}
